import { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting-js';
import { AppContext } from '@prisjakt/ui-app-context';

import marketSettings from './market-settings';

import codes from './codes';

export const formatCurrency = (price, market, asDiff, code) => {
  const settings = marketSettings[market];

  if (!settings || price === undefined || price === null) {
    return null;
  }

  const overrideCode = codes[code && code.toLowerCase()];
  const { withDecimals, numberOfDecimals, symbol, format } =
    overrideCode || settings;
  const decimals = numberOfDecimals !== undefined ? numberOfDecimals : 2;

  const formattedPrice = accounting.formatMoney(price, {
    symbol,
    decimal: settings.decimalSign,
    precision: withDecimals ? decimals : 0,
    thousand: settings.thousandSeparator,
    format,
  });

  if (asDiff && price > 0) {
    return `+${formattedPrice}`;
  }

  return formattedPrice;
};

const Currency = ({ price, market, asDiff, code }) => {
  const context = useContext(AppContext);
  const marketFromParamOrContext =
    market || (context.market && context.market.code);

  return formatCurrency(price, marketFromParamOrContext, asDiff, code);
};

const { number, string, bool, oneOfType } = PropTypes;

Currency.propTypes = {
  market: string,
  price: oneOfType([string, number]),
  asDiff: bool,
  code: string,
};

Currency.defaultProps = {
  market: undefined,
  price: null,
  asDiff: false,
  code: '',
};

export default memo(Currency);
